import { getInventory, IInventoryResponseBody } from 'src/api/getInventory';
import { useSnackbar } from '@weareopenr/component-library';
import { InventoryItemType } from 'src/types/inventory.types';
import { getBrandId } from '../../helpers/getBrandId/getBrandId';
import { useInfiniteQuery, UseInfiniteQueryOptions, UseInfiniteQueryResult } from '@tanstack/react-query';
import { parseQueryParamsFromRelativeUrlPath } from 'src/helpers';
import { QueryKeys } from '../QueryKeys';
import { inventoryError } from 'src/mocks/data';

export const useInventory = (
  limit = 50,
  searchQuery?: string,
  productType?: InventoryItemType[],
  options?: UseInfiniteQueryOptions<IInventoryResponseBody>,
): UseInfiniteQueryResult<IInventoryResponseBody> => {
  const { showSnackbar } = useSnackbar();
  return useInfiniteQuery({
    queryKey: [QueryKeys.inventory, getBrandId(), searchQuery, productType],
    queryFn: async ({ pageParam }) => getInventory(limit, pageParam, searchQuery, productType),
    refetchOnWindowFocus: false,
    onError: () => showSnackbar(inventoryError),
    getNextPageParam: (lastPage) => {
      const nextPageUrlPath = lastPage?.paging?.next;

      if (!nextPageUrlPath) return null;
      return parseQueryParamsFromRelativeUrlPath(nextPageUrlPath).get('after_id');
    },
    ...options,
  });
};
